/* ADD DATA-ZOOM ATTRIBUTE ON CLICKED IMAGE TO OPEN IT ON ZOOM POPUP */
let images = document.querySelectorAll('.product__medias.hidden-pocket img');
images.forEach(image => {
  image.addEventListener('click', () => {
    image.setAttribute('data-zoom', 'true');
  });
});

/* CLOSE POPUP ZOOM */
let closeZoomPopup = document.querySelector('.pswp__button--close');
closeZoomPopup.addEventListener('click', () => {
  let zoomImages = document.querySelectorAll('.product__medias.hidden-pocket img');
  zoomImages.forEach(image => {
    image.removeAttribute('data-zoom');
  });
});

/* SHOW MORE BUTTON DESCRIPTION */
window.addEventListener('load', () => {
  let showMoreButton = document.getElementById('show-more-button');
  let showMoreText = document.querySelector('.product-form__show-more-button .more');
  let showLessText = document.querySelector('.product-form__show-more-button .less');
  let productDescription = document.getElementById('description');
  if (productDescription.scrollHeight > productDescription.clientHeight) {
    showMoreButton.classList.remove('is-invisible');
  } else {
    productDescription.classList.remove('is-collapsed');
  }
  if (showMoreButton) {
    showMoreButton.addEventListener('click', () => {
      productDescription.classList.toggle('is-collapsed');
      showMoreText.classList.toggle('is-invisible');
      showLessText.classList.toggle('is-visible');
    });
  }
});

/* MOBILE ZOOM WITH PINCH-ZOOM-JS */
const flickityCarousel = document.querySelector('.product__media-list.hidden-lap-and-up');
if (flickityCarousel) {
  const flickityImages = flickityCarousel.querySelectorAll('img');
  flickityImages.forEach(image => {
    const pinchZoom = new window.PinchZoom.default(image, {
      draggableUnzoomed: false,
      maxZoom: 3,
      zoomOutFactor: 4,
      minZoom: 1,
      contain: true
    });
  });
}